import React from "react";
import "./CTA.css";

function CTA() {
  return (
    <div className="cta_container">
      <div className="cta_background">
        <div className="cta_content">
          <div className="cta_text">
            <h2>Need Professional <span>Home Maintenance?</span></h2>
            <p>Get fast, reliable home repair and maintenance services in Dubai. Request a free quote today — transparent pricing with no hidden charges.</p>
            
            <div className="cta_highlights">
              <span className="highlight_item">✓ Free Estimate</span>
              <span className="highlight_item">✓ Fast Response</span>
              <span className="highlight_item">✓ 24/7 Emergency</span>
              <span className="highlight_item">✓ Licensed Professionals</span>
            </div>
          </div>

        </div>

        <div className="cta_stats">
          <div className="cta_stat">
            <h4>5000+</h4>
            <p>Happy Customers</p>
          </div>
          <div className="cta_divider"></div>
          <div className="cta_stat">
            <h4>2500+</h4>
            <p>Projects Done</p>
          </div>
          <div className="cta_divider"></div>
          <div className="cta_stat">
            <h4>24/7</h4>
            <p>Emergency Support</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CTA;
